var React = require('react');

function AccountInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.7917 5.54167C15.7917 8.62917 13.3375 11.0833 10.25 11.0833C7.1625 11.0833 4.70833 8.62917 4.70833 5.54167C4.70833 2.45417 7.1625 0 10.25 0C13.3375 0 15.7917 2.45417 15.7917 5.54167ZM14.525 11.2417C13.3375 12.1125 11.8333 12.6667 10.25 12.6667C8.66667 12.6667 7.1625 12.1125 5.975 11.2417C2.72917 12.6667 0.75 17.1 0.75 19H19.75C19.75 17.1 17.6917 12.6667 14.525 11.2417Z","fill":"black"}));
}

AccountInline.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = AccountInline;

AccountInline.default = AccountInline;
